import * as Icons from '@ant-design/icons';

export const antdIconsMap = {
	accountBookOutlined: Icons.AccountBookOutlined,
	alertOutlined: Icons.AlertOutlined,
	apartmentOutlined: Icons.ApartmentOutlined,
	apiOutlined: Icons.ApiOutlined,
	appstoreAddOutlined: Icons.AppstoreAddOutlined,
	appstoreOutlined: Icons.AppstoreOutlined,
	areaChartOutlined: Icons.AreaChartOutlined,
	arrowDownOutlined: Icons.ArrowDownOutlined,
	arrowLeftOutlined: Icons.ArrowLeftOutlined,
	arrowRightOutlined: Icons.ArrowRightOutlined,
	arrowUpOutlined: Icons.ArrowUpOutlined,
	audioMutedOutlined: Icons.AudioMutedOutlined,
	audioOutlined: Icons.AudioOutlined,
	auditOutlined: Icons.AuditOutlined,
	bankOutlined: Icons.BankOutlined,
	barChartOutlined: Icons.BarChartOutlined,
	barcodeOutlined: Icons.BarcodeOutlined,
	barsOutlined: Icons.BarsOutlined,
	behanceOutlined: Icons.BehanceOutlined,
	bellOutlined: Icons.BellOutlined,
	blockOutlined: Icons.BlockOutlined,
	boldOutlined: Icons.BoldOutlined,
	bookOutlined: Icons.BookOutlined,
	borderOutlined: Icons.BorderOutlined,
	borderlessTableOutlined: Icons.BorderlessTableOutlined,
	branchesOutlined: Icons.BranchesOutlined,
	bugOutlined: Icons.BugOutlined,
	buildOutlined: Icons.BuildOutlined,
	bulbOutlined: Icons.BulbOutlined,
	calculatorOutlined: Icons.CalculatorOutlined,
	calendarOutlined: Icons.CalendarOutlined,
	cameraOutlined: Icons.CameraOutlined,
	carOutlined: Icons.CarOutlined,
	carryOutOutlined: Icons.CarryOutOutlined,
	checkCircleOutlined: Icons.CheckCircleOutlined,
	checkOutlined: Icons.CheckOutlined,
	ciOutlined: Icons.CiOutlined,
	clearOutlined: Icons.ClearOutlined,
	clockCircleOutlined: Icons.ClockCircleOutlined,
	closeCircleOutlined: Icons.CloseCircleOutlined,
	closeOutlined: Icons.CloseOutlined,
	cloudDownloadOutlined: Icons.CloudDownloadOutlined,
	cloudOutlined: Icons.CloudOutlined,
	cloudServerOutlined: Icons.CloudServerOutlined,
	codeOutlined: Icons.CodeOutlined,
	coffeeOutlined: Icons.CoffeeOutlined,
	compassOutlined: Icons.CompassOutlined,
	contactsOutlined: Icons.ContactsOutlined,
	containerOutlined: Icons.ContainerOutlined,
	controlOutlined: Icons.ControlOutlined,
	copyOutlined: Icons.CopyOutlined,
	copyrightOutlined: Icons.CopyrightOutlined,
	creditCardOutlined: Icons.CreditCardOutlined,
	crownOutlined: Icons.CrownOutlined,
	customerServiceOutlined: Icons.CustomerServiceOutlined,
	dashboardOutlined: Icons.DashboardOutlined,
	databaseOutlined: Icons.DatabaseOutlined,
	deleteOutlined: Icons.DeleteOutlined,
	deploymentUnitOutlined: Icons.DeploymentUnitOutlined,
	desktopOutlined: Icons.DesktopOutlined,
	disconnectOutlined: Icons.DisconnectOutlined,
	dislikeOutlined: Icons.DislikeOutlined,
	dollarOutlined: Icons.DollarOutlined,
	downloadOutlined: Icons.DownloadOutlined,
	editOutlined: Icons.EditOutlined,
	environmentOutlined: Icons.EnvironmentOutlined,
	euroOutlined: Icons.EuroOutlined,
	exclamationCircleOutlined: Icons.ExclamationCircleOutlined,
	experimentOutlined: Icons.ExperimentOutlined,
	eyeInvisibleOutlined: Icons.EyeInvisibleOutlined,
	eyeOutlined: Icons.EyeOutlined,
	fileAddOutlined: Icons.FileAddOutlined,
	fileExcelOutlined: Icons.FileExcelOutlined,
	fileExclamationOutlined: Icons.FileExclamationOutlined,
	fileImageOutlined: Icons.FileImageOutlined,
	fileMarkdownOutlined: Icons.FileMarkdownOutlined,
	filePdfOutlined: Icons.FilePdfOutlined,
	fileOutlined: Icons.FileOutlined,
	fileSearchOutlined: Icons.FileSearchOutlined,
	fileTextOutlined: Icons.FileTextOutlined,
	fileWordOutlined: Icons.FileWordOutlined,
	flagOutlined: Icons.FlagOutlined,
	folderAddOutlined: Icons.FolderAddOutlined,
	folderOpenOutlined: Icons.FolderOpenOutlined,
	folderOutlined: Icons.FolderOutlined,
	fundOutlined: Icons.FundOutlined,
	gatewayOutlined: Icons.GatewayOutlined,
	giftOutlined: Icons.GiftOutlined,
	globalOutlined: Icons.GlobalOutlined,
	goldOutlined: Icons.GoldOutlined,
	heartOutlined: Icons.HeartOutlined,
	homeOutlined: Icons.HomeOutlined,
	hourglassOutlined: Icons.HourglassOutlined,
	idcardOutlined: Icons.IdcardOutlined,
	inboxOutlined: Icons.InboxOutlined,
	infoCircleOutlined: Icons.InfoCircleOutlined,
	insuranceOutlined: Icons.InsuranceOutlined,
	interactionOutlined: Icons.InteractionOutlined,
	layoutOutlined: Icons.LayoutOutlined,
	likeOutlined: Icons.LikeOutlined,
	lineChartOutlined: Icons.LineChartOutlined,
	linkOutlined: Icons.LinkOutlined,
	loading3QuartersOutlined: Icons.Loading3QuartersOutlined,
	loadingOutlined: Icons.LoadingOutlined,
	lockOutlined: Icons.LockOutlined,
	loginOutlined: Icons.LoginOutlined,
	logoutOutlined: Icons.LogoutOutlined,
	mailOutlined: Icons.MailOutlined,
	manOutlined: Icons.ManOutlined,
	medicineBoxOutlined: Icons.MedicineBoxOutlined,
	messageOutlined: Icons.MessageOutlined,
	mobileOutlined: Icons.MobileOutlined,
	moneyCollectOutlined: Icons.MoneyCollectOutlined,
	notificationOutlined: Icons.NotificationOutlined,
	phoneOutlined: Icons.PhoneOutlined,
	pictureOutlined: Icons.PictureOutlined,
	pieChartOutlined: Icons.PieChartOutlined,
	playCircleOutlined: Icons.PlayCircleOutlined,
	printerOutlined: Icons.PrinterOutlined,
	profileOutlined: Icons.ProfileOutlined,
	projectOutlined: Icons.ProjectOutlined,
	pushpinOutlined: Icons.PushpinOutlined,
	questionCircleOutlined: Icons.QuestionCircleOutlined,
	readOutlined: Icons.ReadOutlined,
	reconciliationOutlined: Icons.ReconciliationOutlined,
	reloadOutlined: Icons.ReloadOutlined,
	retweetOutlined: Icons.RetweetOutlined,
	rocketOutlined: Icons.RocketOutlined,
	safetyCertificateOutlined: Icons.SafetyCertificateOutlined,
	saveOutlined: Icons.SaveOutlined,
	scheduleOutlined: Icons.ScheduleOutlined,
	searchOutlined: Icons.SearchOutlined,
	securityScanOutlined: Icons.SecurityScanOutlined,
	settingOutlined: Icons.SettingOutlined,
	shakeOutlined: Icons.ShakeOutlined,
	shareAltOutlined: Icons.ShareAltOutlined,
	shoppingCartOutlined: Icons.ShoppingCartOutlined,
	shopOutlined: Icons.ShopOutlined,
	shrinkOutlined: Icons.ShrinkOutlined,
	skinOutlined: Icons.SkinOutlined,
	smileOutlined: Icons.SmileOutlined,
	solutionOutlined: Icons.SolutionOutlined,
	soundOutlined: Icons.SoundOutlined,
	starOutlined: Icons.StarOutlined,
	stopOutlined: Icons.StopOutlined,
	switcherOutlined: Icons.SwitcherOutlined,
	syncOutlined: Icons.SyncOutlined,
	tabletOutlined: Icons.TabletOutlined,
	tagOutlined: Icons.TagOutlined,
	tagsOutlined: Icons.TagsOutlined,
	teamOutlined: Icons.TeamOutlined,
	toolOutlined: Icons.ToolOutlined,
	trademarkCircleOutlined: Icons.TrademarkCircleOutlined,
	trophyOutlined: Icons.TrophyOutlined,
	unlockOutlined: Icons.UnlockOutlined,
	uploadOutlined: Icons.UploadOutlined,
	userAddOutlined: Icons.UserAddOutlined,
	userDeleteOutlined: Icons.UserDeleteOutlined,
	userOutlined: Icons.UserOutlined,
	userSwitchOutlined: Icons.UserSwitchOutlined,
	videoCameraOutlined: Icons.VideoCameraOutlined,
	walletOutlined: Icons.WalletOutlined,
	warningOutlined: Icons.WarningOutlined,
	wifiOutlined: Icons.WifiOutlined,
	womanOutlined: Icons.WomanOutlined,
};

export default antdIconsMap;
